"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTML_ELEMENTS_CLASSES = exports.EnumReferenceEntity = exports.EnumGeneratedBy = exports.EnumUserAuthentication = exports.EnumCellType = exports.EnumLoggingScreenNames = exports.EnumActionNameLevel3 = exports.EnumActionNameLevel2 = exports.EnumActionNameLevel1 = exports.EnumWidgets = exports.EnumUxTypes = void 0;
var EnumUxTypes;
(function (EnumUxTypes) {
    EnumUxTypes["LINK"] = "link";
    EnumUxTypes["BUTTON"] = "button";
    EnumUxTypes["BUTTON_FLOATING"] = "button_floating";
    EnumUxTypes["BUTTON_BOTTOM_BAR"] = "button_bottombar";
    EnumUxTypes["BUTTON_TOP_BAR"] = "button_topbar";
    EnumUxTypes["BUTTON_TOGGLE"] = "button_toggle";
    EnumUxTypes["ICON"] = "icon";
    EnumUxTypes["ICON_MENU_ITEM"] = "icon_menu_item";
    EnumUxTypes["IMAGE"] = "image";
    EnumUxTypes["LIST_CELL"] = "list_cell";
    EnumUxTypes["LIST"] = "list";
    EnumUxTypes["SWIPE"] = "swipe";
    EnumUxTypes["SCROLL"] = "scroll";
    EnumUxTypes["TAB"] = "tab";
    EnumUxTypes["SLIDER"] = "slider";
    EnumUxTypes["CHECKBOX"] = "checkbox";
    EnumUxTypes["RADIO"] = "radio";
    EnumUxTypes["VIDEO"] = "video";
    EnumUxTypes["SCREEN"] = "screen";
    EnumUxTypes["MODAL"] = "modal";
    EnumUxTypes["RATING_ADD"] = "ratings_add";
    EnumUxTypes["NA"] = "NA";
})(EnumUxTypes = exports.EnumUxTypes || (exports.EnumUxTypes = {}));
var EnumWidgets;
(function (EnumWidgets) {
    EnumWidgets["AD_UNTIL"] = "ad_unit";
    EnumWidgets["ADD_LISTING"] = "add_listing";
    EnumWidgets["ADD_LISTING_SIMILAR"] = "add_listing_similar";
    EnumWidgets["BOTTOM_STICKY"] = "bottom_sticky";
    EnumWidgets["CATEGORIES_LIST_ICON"] = "categories_list_icons";
    EnumWidgets["CONTACT_US"] = "contact_US";
    EnumWidgets["EXPORT_LISTING_OPTIONS"] = "export_listing_options";
    EnumWidgets["FILTERS"] = "filters";
    EnumWidgets["FILTERS_FACETS"] = "filters_facets";
    EnumWidgets["GENERAL_TIPS"] = "general_tips";
    EnumWidgets["HEADER"] = "header";
    EnumWidgets["HEADER_STICKY"] = "header_sticky";
    EnumWidgets["REELS_LIST"] = "reels_list";
    EnumWidgets["LISTINGS_CONTINUE_BROWSING"] = "listings_continue_browsing";
    EnumWidgets["LISTING_RECENTLY_VIEWED"] = "listings_recently_viewed";
    EnumWidgets["LISTING_LATEST_BY_CATEGORY"] = "listings_latest_by_category";
    EnumWidgets["LISTING_LOCATION_MAP"] = "listing_location_and_map";
    EnumWidgets["LISTING_INFORMATION"] = "listing_information";
    EnumWidgets["LISTING_DESCRIPTION"] = "listing_description";
    EnumWidgets["LISTING_IMAGE"] = "listing_image";
    EnumWidgets["LISTING_TITLE"] = "listing_title";
    EnumWidgets["LISTING_PRICE"] = "listing_price";
    EnumWidgets["LISTING_CELL"] = "listing_cell";
    EnumWidgets["LISTING_LEADS"] = "listing_leads";
    EnumWidgets["LISTER_OVERVIEW"] = "lister_overview";
    EnumWidgets["LISTER_MEMBER_OPENSOOQ_LINK"] = "lister_member_opensooq_link";
    EnumWidgets["LISTING_SIMILAR"] = "listings_similar";
    EnumWidgets["LISTING_RECOMMENDED"] = "listings_recommended";
    EnumWidgets["LISTING_QUALITY_SCORE"] = "listing_quality_score";
    EnumWidgets["LISTING_STATISTICS"] = "listing_statistics";
    EnumWidgets["LISTING_DETAILS"] = "listing_details";
    EnumWidgets["NAVIGATION_BOTTOM_BAR"] = "navigation_bottom_bar";
    EnumWidgets["RESULTS_HEADER"] = "results_header";
    EnumWidgets["RATING_ADD"] = "ratings_add";
    EnumWidgets["RATING_SUMMARY"] = "ratings_summary";
    EnumWidgets["RATING_BADGES"] = "ratings_badges";
    EnumWidgets["RATING_REVIEWS"] = "ratings_reviews";
    EnumWidgets["PROMOTE_LISTING"] = "promote_listing";
    EnumWidgets["SPOTLIGHT_BOTTUN"] = "spotlight_button";
    EnumWidgets["SHARE_LISTING_OPTIONS"] = "share_listing_options";
    EnumWidgets["SEARCH_BAR"] = "search_bar";
    EnumWidgets["SLIDERS"] = "sliders";
    EnumWidgets["TABS"] = "tabs";
    EnumWidgets["WALLET_CELL"] = "wallet_cell";
    EnumWidgets["BOTTOM_BAR"] = "bottom_bar";
    EnumWidgets["NA"] = "NA";
})(EnumWidgets = exports.EnumWidgets || (exports.EnumWidgets = {}));
var EnumActionNameLevel1;
(function (EnumActionNameLevel1) {
    EnumActionNameLevel1["CALL"] = "call";
    EnumActionNameLevel1["APPLY"] = "apply";
    EnumActionNameLevel1["ADD"] = "add";
    EnumActionNameLevel1["VIEW"] = "view";
    EnumActionNameLevel1["ORDER"] = "order";
    EnumActionNameLevel1["FAVORITE"] = "favorite";
    EnumActionNameLevel1["MESSAGE"] = "message";
    EnumActionNameLevel1["AUTHENTICATE"] = "authenticate";
    EnumActionNameLevel1["FOLLOW"] = "follow";
    EnumActionNameLevel1["SEARCHES_SAVE"] = "searches_save";
    EnumActionNameLevel1["SHARE"] = "share";
    EnumActionNameLevel1["REPORT"] = "report";
    EnumActionNameLevel1["RATING"] = "rating";
    EnumActionNameLevel1["SEARCH"] = "search";
    EnumActionNameLevel1["SCREEN"] = "screen";
    EnumActionNameLevel1["ACCOUNT"] = "account";
    EnumActionNameLevel1["NA"] = "NA";
})(EnumActionNameLevel1 = exports.EnumActionNameLevel1 || (exports.EnumActionNameLevel1 = {}));
var EnumActionNameLevel2;
(function (EnumActionNameLevel2) {
    EnumActionNameLevel2["LOAN"] = "loan";
    EnumActionNameLevel2["LISTING"] = "listing";
    EnumActionNameLevel2["CV"] = "cv";
    EnumActionNameLevel2["MEMBER"] = "member";
    EnumActionNameLevel2["LISTING_ADD"] = "listing_add";
    EnumActionNameLevel2["LISTING_REMOVE"] = "listing_remove";
    EnumActionNameLevel2["ADD"] = "add";
    EnumActionNameLevel2["REMOVE"] = "remove";
    EnumActionNameLevel2["SEARCH"] = "search";
    EnumActionNameLevel2["APP"] = "app";
    EnumActionNameLevel2["KEYWORD"] = "keyword";
    EnumActionNameLevel2["TAXONOMY"] = "taxonomy";
    EnumActionNameLevel2["FILTERS"] = "filters";
    EnumActionNameLevel2["SIMILAR"] = "similar";
    EnumActionNameLevel2["LOAD"] = "load";
    EnumActionNameLevel2["START"] = "start";
    EnumActionNameLevel2["PRODUCTS"] = "products";
    EnumActionNameLevel2["COMMON"] = "common";
    EnumActionNameLevel2["LOGIN"] = "login";
    EnumActionNameLevel2["REGISTER"] = "register";
    EnumActionNameLevel2["FORGOT_PASSWORD"] = "forgot_password";
    EnumActionNameLevel2["CHANGE_PASSWORD"] = "change_password";
    EnumActionNameLevel2["CHANGE_MOBILE"] = "change_mobile";
})(EnumActionNameLevel2 = exports.EnumActionNameLevel2 || (exports.EnumActionNameLevel2 = {}));
var EnumActionNameLevel3;
(function (EnumActionNameLevel3) {
    EnumActionNameLevel3["CLICK"] = "click";
    EnumActionNameLevel3["SUCCESS"] = "success";
    EnumActionNameLevel3["VIEW"] = "view";
    EnumActionNameLevel3["SUBMIT"] = "submit";
    EnumActionNameLevel3["VERIFY"] = "verify";
    EnumActionNameLevel3["VERIFY_SUBMIT"] = "verify_submit";
    EnumActionNameLevel3["USED"] = "used";
    EnumActionNameLevel3["REDIRECT"] = "redirect";
})(EnumActionNameLevel3 = exports.EnumActionNameLevel3 || (exports.EnumActionNameLevel3 = {}));
var EnumLoggingScreenNames;
(function (EnumLoggingScreenNames) {
    EnumLoggingScreenNames["RealEstateForSale"] = "home_realestateforsale_landing";
    EnumLoggingScreenNames["Autos"] = "home_autos_landing";
    EnumLoggingScreenNames["MobileTablet"] = "home_mobiletablet_landing";
    EnumLoggingScreenNames["AUTHENTICATION"] = "authentification";
    EnumLoggingScreenNames["AUTHENTICATION_LOGIN"] = "authentification_login";
    EnumLoggingScreenNames["AUTHENTICATION_LOGIN_SUCCESS"] = "authentification_login_success";
    EnumLoggingScreenNames["AUTHENTICATION_LOGIN_FAILURE"] = "authentification_login_failure";
    EnumLoggingScreenNames["AUTHENTICATION_REGISTER"] = "authentification_register";
    EnumLoggingScreenNames["AUTHENTICATION_REGISTER_SUCCESS"] = "authentification_register_success";
    EnumLoggingScreenNames["AUTHENTICATION_REGISTER_FAILURE"] = "authentification_register_failure";
    EnumLoggingScreenNames["AUTHENTICATION_REGISTER_FORM"] = "authentification_register_form";
    EnumLoggingScreenNames["AUTHENTICATION_RESET_PASSWORD"] = "authentification_reset_password";
    EnumLoggingScreenNames["ACCOUNT_CHANGE_PASSWORD"] = "account_change_password";
    EnumLoggingScreenNames["AUTHENTICATION_RESET_PASSWORD_SUCCESS"] = "authentification_reset_password_success";
    EnumLoggingScreenNames["AUTHENTICATION_RESET_PASSWORD_FAILURE"] = "authentification_reset_password_failure";
    EnumLoggingScreenNames["AUTHENTICATION_RESET_PASSWORD_VERIFY"] = "authentification_reset_password_verify";
    EnumLoggingScreenNames["AUTHENTICATION_REGISTER_VERIFY"] = "authentification_register_verify";
    EnumLoggingScreenNames["ACCOUNT_MOBILE_VERIFY"] = "account_mobile_verify";
    EnumLoggingScreenNames["NA"] = "NA";
    EnumLoggingScreenNames["MY_ACCOUNT_PROFILE"] = "my_account_profile";
})(EnumLoggingScreenNames = exports.EnumLoggingScreenNames || (exports.EnumLoggingScreenNames = {}));
var EnumCellType;
(function (EnumCellType) {
    EnumCellType["TEXT_ONLY"] = "textOnly";
    EnumCellType["CLASSIC"] = "classic";
    EnumCellType["IMAGE"] = "image";
})(EnumCellType = exports.EnumCellType || (exports.EnumCellType = {}));
var EnumUserAuthentication;
(function (EnumUserAuthentication) {
    EnumUserAuthentication["LOGGED_IN"] = "LoggedIn";
    EnumUserAuthentication["LOGGED_OUT"] = "LoggedOut";
})(EnumUserAuthentication = exports.EnumUserAuthentication || (exports.EnumUserAuthentication = {}));
var EnumGeneratedBy;
(function (EnumGeneratedBy) {
    EnumGeneratedBy["USER"] = "user";
    EnumGeneratedBy["SYSTEM"] = "system";
})(EnumGeneratedBy = exports.EnumGeneratedBy || (exports.EnumGeneratedBy = {}));
var EnumReferenceEntity;
(function (EnumReferenceEntity) {
    EnumReferenceEntity["MEMBER"] = "member";
    EnumReferenceEntity["POST"] = "post";
    EnumReferenceEntity["ORDER"] = "order";
    EnumReferenceEntity["SAVED_SEARCH"] = "saved_searches";
})(EnumReferenceEntity = exports.EnumReferenceEntity || (exports.EnumReferenceEntity = {}));
exports.HTML_ELEMENTS_CLASSES = [
    "searchFacetsSource",
    "viewMoreBtnSource",
    "homeFacetsSource",
    "megaMenuSource",
    "moreCategorySource",
];
